import { PortObligatoireDesEpis } from '@assets/images';
import { CustomBottomBar } from '@components';
import { Button, Container, Icon, Modal, Typography, Checkbox } from '@design-system';
import { GrFormCheckmark } from 'react-icons/gr';
import { MdKeyboardArrowRight } from 'react-icons/md';
import './EPIPage.scss';
import { useEPIPageVM } from './useEPIPageVM';

export const EPIPage: React.FC = () => {
    const {
        containerRef,
        handleNext,
        isFinished,
        showModal,
        setShowModal,
        animationClass,
        lastInfo,
        showEPISelection,
        selectedEPIs,
        toggleSelectedEPI,
        handleFinishSelection,
        svgKeys
    } = useEPIPageVM();

    const initialText = (
        <>
            Veuillez consulter chacun des EPI obligatoires à l'aide des marqueurs sur l'écran ou du bouton « Suivant ».
            <br />
            Assurez-vous de respecter le port de ces EPI lorsque vous êtes sur site/chantier.
        </>
    );

    const getEPIDisplayName = (key: string) => {
        const displayNames: Record<string, string> = {
            Casque: 'Casque avec jugulaire',
            Lunettes: 'Protection oculaire (lunettes ou masque)',
            Casque_oreilles: 'Protection auditive adapté selon tâche',
            Vetements: 'Vêtements de travail adaptés',
            Gants: 'Gants anti coupure',
            Chaussures: 'Chaussures de sécurité hautes',
            Masque: 'Protection respiratoire (anti poussière / taupinette)'
        };
        return displayNames[key] || key;
    };

    return (
        <div className="epi-page">
            <Container>
                <Typography intrinsic="h2" className="mb-small-medium-spacing">
                    Port obligatoire des EPIs
                </Typography>

                <Container bordered="grey" ref={containerRef} className="epis-container mb-medium-spacing">
                    <PortObligatoireDesEpis />
                </Container>

                {!isFinished && !showEPISelection && (
                    <Container className={`additional-info ${animationClass}`} padding="medium large">
                        {lastInfo && (
                            <div className="additional-info-image">
                                <img src={lastInfo.image} alt={lastInfo.title} />
                            </div>
                        )}
                        <Typography intrinsic="h4" className={`mb-small-medium-spacing ${lastInfo ? 'has-icon' : ''}`}>
                            {lastInfo && lastInfo.title}
                            {!lastInfo && "N'avez-vous rien oublié ?"}
                        </Typography>
                        <Typography intrinsic="span" color="marine">
                            {lastInfo && lastInfo.description}
                            {!lastInfo && initialText}
                        </Typography>
                    </Container>
                )}

                {showEPISelection && (
                    <Container className="epi-selection-container" padding="medium large">
                        <Typography intrinsic="h4" className="mb-medium-spacing">
                            Cochez les EPIs que vous avez reçus :
                        </Typography>
                        <div className="epi-selection-list">
                            {svgKeys.map((key) => (
                                <div key={key} className="epi-selection-item mb-small-spacing">
                                    <Checkbox
                                        checked={selectedEPIs.includes(key)}
                                        onChange={() => toggleSelectedEPI(key)}
                                        label={getEPIDisplayName(key)}
                                    />
                                </div>
                            ))}
                        </div>
                    </Container>
                )}
            </Container>

            {showModal && (
                <Modal open={showModal} setClose={() => setShowModal(false)} title="" className="epi-page-modal" fitContent>
                    <Typography intrinsic="h5" color="grey" className="mb-medium-spacing text-center">
                        L'équipement <br />
                        est complet
                    </Typography>
                    <Icon icon={<GrFormCheckmark />} size={50} color="green" variant="surrounded" bordered className="check-icon" />
                </Modal>
            )}

            <CustomBottomBar>
                <Button
                    color="marine"
                    size="fullwidth"
                    variant="primary"
                    icon={showEPISelection ? <MdKeyboardArrowRight /> : isFinished ? undefined : <MdKeyboardArrowRight />}
                    iconPosition="forced-right"
                    iconColor="white"
                    iconSize={28}
                    disabled={showEPISelection && !selectedEPIs.length}
                    onClick={showEPISelection ? handleFinishSelection : handleNext}
                >
                    <Typography intrinsic="h4">{showEPISelection ? 'Valider' : isFinished ? 'OK' : 'Suivant'}</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
